import { useState, useCallback } from 'react';
import { clearMapForDrawingMode } from '../utils/cesiumHelpers';
export function useProjectPolygonDrawing(viewer, modalActions, clearMapDeps) {
    const [isPolygonDrawing, setIsPolygonDrawing] = useState(false);
    const [polygonProjectName, setPolygonProjectName] = useState('');
    const [polygonProjectDescription, setPolygonProjectDescription] = useState('');
    const handleStartPolygonDrawing = (projectName, projectDescription) => {
        if (viewer) {
            clearMapForDrawingMode(viewer, clearMapDeps.clearAllArtifacts);
        }
        clearMapDeps.clearAllMeasurements();
        clearMapDeps.unhighlightAllContours();
        setPolygonProjectName(projectName);
        setPolygonProjectDescription(projectDescription);
        setIsPolygonDrawing(true);
        modalActions.closeModal();
    };
    const handlePolygonDrawingFinish = useCallback((_projectName, _projectDescription, _coordinates) => {
        setIsPolygonDrawing(false);
        setPolygonProjectName('');
        setPolygonProjectDescription('');
    }, []);
    const handlePolygonDrawingCancel = () => {
        setIsPolygonDrawing(false);
        setPolygonProjectName('');
        setPolygonProjectDescription('');
    };
    const handleEmailVerificationSet = () => {
        setIsPolygonDrawing(false);
        setPolygonProjectName('');
        setPolygonProjectDescription('');
    };
    return {
        isPolygonDrawing,
        polygonProjectName,
        polygonProjectDescription,
        handleStartPolygonDrawing,
        handlePolygonDrawingFinish,
        handlePolygonDrawingCancel,
        handleEmailVerificationSet,
    };
}
